// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Store Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackFileDownloadParameters extends TrackEventBaseParameters<"file_name" | "file_category"> {}

const trackFileDownload = (parameters: TrackFileDownloadParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "file_download", ...parameters }, options);
};

export default trackFileDownload;
